export type HairStrokeValue = string | null

export interface HairStrokeOption {
    key: string
    label: string
    description: string
}

export const HAIR_STROKE_OPTIONS: HairStrokeOption[] = [
    {
        key: 'fino',
        label: 'Fino',
        description: 'Fio delicado, com menor resistência e maior tendência à queda',
    },
    {
        key: 'medio',
        label: 'Médio',
        description: 'Espessura intermediária, o padrão mais comum',
    },
    {
        key: 'grosso',
        label: 'Grosso',
        description: 'Fio resistente, com maior diâmetro e volume natural',
    },
]

export function findHairStroke(key: HairStrokeValue): HairStrokeOption | null {
    return HAIR_STROKE_OPTIONS.find((option) => option.key === key) ?? null
}

export function isHairStrokeValueEmpty(value: HairStrokeValue | undefined): boolean {
    return !value
}
